// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8aa0c319","713":"6debc0cd"}[chunkId] + ".chunk.js";
};